import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { FetchBusinessRequest, SetDefaultData } from '../businesses.actions'
import { getUpdateBusinessState } from '../businesses.selectors'

@Component({
  selector: 'app-update-business',
  templateUrl: './update-business.component.html',
  styleUrls: ['./update-business.component.css'],
})
export class UpdateBusinessComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public businessId: number
  public tab: string
  public routerEvents$: Subscription
  public state$: Subscription
  public isReadonly: boolean = false
  public issues: any[] = []

  constructor(
    public store: Store<any>,
    private route: ActivatedRoute,
    public router: Router,
  ) {
    super()
  }

  ngOnInit() {
    this.businessId = parseInt(this.route.snapshot.paramMap.get('id'))
    this.tab = this.route.snapshot.paramMap.get('tab')

    this.routerEvents$ = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        const urlSegments = e.url.split('/')
        this.tab = urlSegments[urlSegments.length - 1]
      }
    })

    this.state$ = this.store
      .pipe(select(getUpdateBusinessState))
      .subscribe((state) => {
        this.state = state
        const status = state.getIn(['data', 'status', 'name'])
        this.isReadonly = status === 'ARCHIVED'
        const issues = state.getIn(['data', 'issues'])
        this.issues = issues ? issues.toJS() : []
      })

    if (this.businessId) {
      this.store.dispatch<any>(new FetchBusinessRequest(this.businessId))
    }
  }

  ngOnDestroy() {
    this.routerEvents$.unsubscribe()
    if (this.state$) {
      this.state$.unsubscribe()
    }
  }

  onTabChange(key: string) {
    this.router.navigate([`/licenses`, this.businessId, key])
  }
}
